import React from 'react';

interface Props {
  className: string;
  size: number;
}

const SortIcon = ({className = '', size = 24}: Props) => (
  <span className={className}>
    <svg
      fill="#366aff"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <title>Edit Sorting</title>
      <path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  </span>
);

export default SortIcon;
